export default {
  methods: {
    back() {
      this.$emit("back", "InviteSuccess");
    }
  }
};